import { useState, useEffect } from 'react'
import { getCountdownTarget } from '../../utils/masterclassSchedule'

export default function MasterclassCountdown({ eventDate }) {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 })

  useEffect(() => {
    const target = getCountdownTarget(eventDate)
    const tick = () => {
      const diff = target - new Date()
      if (diff <= 0) { setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 }); return }
      setTimeLeft({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      })
    }
    tick()
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [eventDate])

  const pad = (n) => String(n).padStart(2, '0')

  return (
    <div className="mt-4">
      <p className="cinema-label mb-4">Next Masterclass Starts In</p>
      <div className="grid grid-cols-4 gap-px overflow-hidden">
        {[['Days', timeLeft.days], ['Hours', timeLeft.hours], ['Mins', timeLeft.minutes], ['Secs', timeLeft.seconds]].map(([label, val]) => (
          <div key={label} className="text-center px-3 py-4">
            <div className="font-display text-3xl font-light text-cinema-gold tabular-nums leading-none">{pad(val)}</div>
            <div className="text-[9px] uppercase tracking-[0.2em] text-cinema-muted mt-2 font-sans">{label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
